export default "__VITE_ASSET__BL3zV7l3__"